module.exports = __webpack_public_path__ + "img/zjyt_img@2x.bb5265c3.png";